import { connect } from 'react-redux';
import Component from './Component';

const mapStateToProps = (state) => ({
  valuation: state.screens.ValuationView.valuation,
})

const actionCreators = {};

export default connect(mapStateToProps, actionCreators)(Component);